module.exports = __webpack_public_path__ + "img/NAVi_RGB-01.a79d86e7.png";